// AURA — Refonte 2026 (draft theme only).
// Mobile sticky add-to-cart: mirrors the main product form's submit button and
// appears once that button scrolls out of view. It clicks the real button, so
// variant selection, quantity and the theme's cart drawer keep working.
(() => {
  const bar = document.querySelector('.aura-sticky-atc');
  if (!bar) return;

  // The product section holds more than one /cart/add form (installments use
  // one too); anchor on the real Add to cart button and take its own form.
  const realButton = document.querySelector(
    '.product-information form[action*="/cart/add"] button[name="add"], .product-information form[action*="/cart/add"] button[type="submit"]'
  );
  const form = realButton?.form;
  if (!form || !realButton) {
    bar.remove();
    return;
  }

  const button = bar.querySelector('.aura-sticky-atc__button');
  const price = bar.querySelector('.aura-sticky-atc__price');
  const mainPrice = () =>
    document.querySelector('.product-information product-price .price, .product-information product-price')?.textContent?.trim();

  const sync = () => {
    const text = mainPrice();
    if (text && price) price.textContent = text.split(/\s{2,}|\n/)[0];
    const disabled = realButton.disabled || realButton.getAttribute('aria-disabled') === 'true';
    button.disabled = disabled;
    button.textContent = disabled ? 'Sold out' : 'Add to cart';
  };

  sync();
  document.addEventListener('variant:update', sync);
  form.addEventListener('change', () => setTimeout(sync, 50));

  button.addEventListener('click', () => realButton.click());

  new IntersectionObserver(
    ([entry]) => {
      const pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.dataset.visible = String(pastButton);
      bar.setAttribute('aria-hidden', String(!pastButton));
    },
    { threshold: 0 }
  ).observe(realButton);
})();
